import React from 'react';
import { DEFAULT_ICON_SIZE, ICONS_MAP } from './iconsMap';

/**
 * VIcon component - A flexible icon component with color customization
 * @param {Object} props - Component props
 * @param {string} props.name - Icon name from the icons provider
 * @param {number} [props.size=24] - Icon size in pixels
 * @param {string} [props.color] - Icon color (will use theme default if not provided)
 * @param {Object} [props.style={}] - Additional CSS styles
 * @param {Object} [props...] - Additional props passed to the underlying element
 * @returns {JSX.Element|null} The icon component or null if icon not found
 */
const VIcon = ({ name, size = DEFAULT_ICON_SIZE, color, style = {}, ...props }) => {
  const iconSrc = ICONS_MAP[name] || ICONS_MAP['circle-questionmark'];

  const baseStyles = {
    width: size,
    height: size,
    display: 'inline-block',
    ...style,
  };

  if (color) {
    const usesInheritedColor = color === 'inherit' || color === 'currentColor';
    const backgroundColor = usesInheritedColor ? 'currentColor' : color;

    return (
      <span
        role="img"
        aria-label={name}
        style={{
          ...baseStyles,
          backgroundColor,
          WebkitMaskImage: `url(${iconSrc})`,
          maskImage: `url(${iconSrc})`,
          WebkitMaskRepeat: 'no-repeat',
          maskRepeat: 'no-repeat',
          WebkitMaskPosition: 'center',
          maskPosition: 'center',
          WebkitMaskSize: 'contain',
          maskSize: 'contain',
          color: usesInheritedColor ? 'inherit' : undefined,
        }}
        {...props}
      />
    );
  }

  return <img src={iconSrc} alt={name} style={baseStyles} {...props} />;
};

export default VIcon;
